import { JetView } from 'webix-jet';
import { devConfig, countries, profile } from 'config/config';

/**
 * Class representing the FilterLogsUseriew.
 * Extends JetView to create a user interface for filtering logs.
 */
export default class FilterLogsUseriew extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'NoteId',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('ID'), // ID input field
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'text',
                            name: 'UserFrom',
                            label: _('Emisor'), // Sender input field
                            labelPosition: 'top',
                            placeholder: _('Emisor'),
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Date range input
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'), // Creation date input
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit date selection to today
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'Type',
                            id: 'Type',
                            label: "<span class='icon-mail'></span>" + _('Tipo'), // Type selection
                            labelPosition: 'top',
                            placeholder: _('Tipo'),
                            options: [],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'ReferenceId',
                            label: _('Referencia'), // Reference input field
                            labelPosition: 'top',
                            placeholder: _('Referencia'),
                        },
                        { gravity: 3, id: 'grav' }, // Placeholder for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section with filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Nota'), // Add Note button
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction('balanceAdjustmentsAdd', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-balanceAdjustmentsAdd',
                    click: () => {
                        this.app.callEvent('addAdjustment:button', [{}]); // Event for adding adjustment
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Clear form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue(''); // Reset datepicker
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter data
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if condition met
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition met
                            }
                        }
                        this.app.callEvent('filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Añadir Nota'), // Add Note button in popup
                    type: 'form',
                    hidden: !devConfig.getPermAction('balanceAdjustmentsAdd', 'Add'),
                    css: 'prm-balanceAdjustmentsAdd',
                    click: () => {
                        this.app.callEvent('addAdjustment:button', [{}]); // Event for adding adjustment
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button in popup
                    click: () => {
                        $$('myForm2').clear(); // Clear popup form values
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button in popup
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter data from popup
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if condition met
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition met
                            }
                        }
                        this.app.callEvent('filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide popup after filtering
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section with filters and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Scrollable section for filters
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup header
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Popup form with filters and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if condition met
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
